import { omit } from 'util/object'

export type QueryData = Record<string, string | number | boolean | null | undefined>

export function formatQuery(x: QueryData): string {
  const raw = new URLSearchParams(omit(x) as any).toString()
  const simple = raw.split('&').map(it => it.split('=').filter(v => v).join('=')).join('&')
  return simple ? '?' + simple : ''
}
